<form [formGroup]="requestForm" (ngSubmit)="apply()" novalidate>
  <h2 mat-dialog-title>New Committee Request</h2>
  <mat-dialog-content class="large-dialog-content">
    <!-- Request Type Toggle -->
    <div class="request-type-section">
      <div class="type-label">Type of request</div>
      <mat-button-toggle-group [(ngModel)]="requestType" [ngModelOptions]="{standalone: true}" class="request-toggle">
        <mat-button-toggle value="priority">Priority</mat-button-toggle>
        <mat-button-toggle value="extraWaitTime">Extra wait time</mat-button-toggle>
      </mat-button-toggle-group>
    </div>

    <!-- Recipient Info -->
    <div class="pairs">
      <div class="row" *ngIf="recipient">
        <span class="label">Requesting for Recipient: </span>
        <span class="value"> {{ recipient!.enisNumber }}</span>
        <span class="flex">{{ recipient.firstName || "" }} {{ recipient.lastName || "" }}</span>
      </div>
    </div>

    <!-- Priority Request Form -->
    <ng-container *ngIf="requestType === 'priority'">
      <!-- Additional Privileges -->
      <div class="privileges-section">
        <h3>Additional Privileges (optional)</h3>
        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Delisted Unacceptables</mat-label>
          <input matInput formControlName="requestedAcceptableHla" placeholder="e.g., A1, A2, B7, B8" />
          <mat-hint>Enter the Delisted Unacceptables antigens for this recipient</mat-hint>
        </mat-form-field>

        <mat-form-field appearance="fill" class="full-width">
          <mat-label>Acceptable Blood Types</mat-label>
          <mat-select formControlName="requestedAcceptableBloodTypes" multiple>
            <mat-option value="O">O</mat-option>
            <mat-option value="A">A</mat-option>
            <mat-option value="B">B</mat-option>
            <mat-option value="AB">AB</mat-option>
          </mat-select>
          <mat-hint>Select the acceptable blood types for this recipient</mat-hint>
        </mat-form-field>
      </div>
    </ng-container>

    <!-- Extra Wait Time Request Form -->
    <ng-container *ngIf="requestType === 'extraWaitTime'">
      <div class="info-box">
        <mat-icon class="info-icon">info</mat-icon>
        <div class="info-content">
          <div class="info-title">Wait Time Privilege:</div>
          <div class="info-text">
            Requesting <strong>3 years extra waiting time</strong>. This privilege applies specifically to <strong>non-immunized former kidney donors</strong> who have become kidney insufficient.
          </div>
        </div>
      </div>
    </ng-container>

    <!-- Rich Text Comment (shown for both types) -->
    <div class="comment-section">
      <mat-label>Request Comment *</mat-label>
      <div class="NgxEditor__Wrapper">
        <ngx-editor-menu [editor]="editor" [toolbar]="toolbar"></ngx-editor-menu>
        <ngx-editor [editor]="editor" formControlName="requestComment" [placeholder]="'Add a comment with a link to the full motivation'"></ngx-editor>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions class="actions">
    <div class="spacer"></div>
    <button mat-button type="button" (click)="cancel()">Cancel</button>
    <span
      [matTooltip]="getSubmitTooltip()"
      matTooltipPosition="above"
      [matTooltipDisabled]="!getSubmitTooltip()"
    >
      <button
        mat-raised-button
        type="submit"
        [disabled]="isSubmitDisabled()"
      >
        Submit
      </button>
    </span>
  </mat-dialog-actions>
</form>
